import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@app/common/global_variables';
import { ListComponent } from '@app/common/templates/list/list.component';
import { Module } from '@app/models/permission';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import { ExportService } from '@app/services/export.service';
import { SettingsService } from '@app/services/settings.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
	templateUrl: '../../../../../common/templates/list/list.component.html',
	styleUrls: ['../style.scss', '../../../../../common/templates/list/style.scss'],
	providers: [MessageService, ConfirmationService]
})
export class AdminVisyConnectionSettingsListComponent extends ListComponent {
	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		public changeDetectorRef: ChangeDetectorRef,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public elRef: ElementRef,
		public exportService: ExportService,
		public globals: Globals,
		public messageService: MessageService,
		public router: Router,
		public settingsService: SettingsService,
		public translate: TranslateService
	) {
		super(accountService, breadcrumbService, changeDetectorRef, confirmationService, crudService, elRef, exportService, globals, messageService, router, settingsService, translate);

		this.apiUrl = 'userConnectionSettings';
		this.name = 'MENU.CONNECTION_SETTINGS';
		this.url = '/' + PATH.CONNECTION_SETTINGS;
		this.module = Module.Masterdata;

		this.possibleCols = [
			{ type: 'text', key: 'Id', required: true, width: 400 },
			{ type: 'text', key: 'SettingsName', required: true, width: 400 },
			{ type: 'text', key: 'ConnectionStringBusinessData', required: true, width: 400 },
			{ type: 'text', key: 'ConnectionStringTblOnline', required: true, width: 400 },
			{ type: 'text', key: 'ConnectionStringMaptour', required: true, width: 400 },
			{ type: 'text', key: 'ConnectionStringServiceData', required: true, width: 400 },
		];
		this.cols = [
			{ type: 'text', key: 'SettingsName', required: true, width: 400 },
		];

		this.breadcrumbService.setItems([
			{ label: 'MENU.STAMMDATEN' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.LIST', routerLink: [this.url + '/' + PATH.LIST] }
		]);
	}
}